import React from 'react';

const Header = () => {
  return (
    <div className="header">
      <div className="border"></div>
      <h1>EV Electric Bill Calculator</h1>
    </div>
  );
};

export default Header;
